import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { RequestParams } from 'Models'
import { Addresses } from 'Pages/orders_design'

async function getAddresses(params: RequestParams) {
	const res = await axiosDS().get<Addresses>(urls.sberGeoUnits.addresses, params)
	return res.data
}

export const sberGeoUnitApi = {
	getAddresses,
}
